import styled from 'styled-components'
import { BaseColor, spacing, themeColor, transitions, Typography } from '~theme'

export const Label = styled.label`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const LabelText = styled.span`
  position: relative;
  flex-grow: 1;
  padding: 0 ${spacing(0.75)};
  color: ${themeColor(BaseColor.shade_60)};
  ${Typography.textSemiStrong};
  ${transitions(['color'])};
  user-select: none;
  cursor: pointer;

  input:disabled ~ & {
    color: ${themeColor(BaseColor.shade_50)};
    cursor: default;
  }
`
